/* src/app/admin/user-report/user-report.component.scss */
/*# sourceMappingURL=user-report.component-JG5S3XY2.css.map */
